import type { Options } from 'ky'
import type {
  GetAdditionalPointsResponse,
  GetSpecialLocationsResponse,
} from '@/types/config'
import { httpClient } from '@/utils/http'

export const configService = {
  getAdditionalPoints: (options?: Options) =>
    httpClient
      .get('additional_points', options)
      .json<GetAdditionalPointsResponse>(),
  getSpecialLocations: (options?: Options) =>
    httpClient
      .get('special_locations', options)
      .json<GetSpecialLocationsResponse>(),
}
